/* global jQuery */

export default class DateTimePicker {
  static selectorString() {
    return '.DateTimePicker';
  }

  render(node, props) {
    jQuery(node)
      .find('input[type="text"]')
      .timepicker({
        minuteStep: 1,
        defaultTime: '',
        showSeconds: false,
        showMeridian: false,
        snapToStep: true,
        use24hours: true,
      })
      .on('show.timepicker', function (e) {
        if (e.time.value === '') {
          if (props.defaulttime) {
            jQuery(this).timepicker('setTime', props.defaulttime);
          }

          if (props.defaulttimereference) {
            const referenceTime = jQuery(props.defaulttimereference).val();
            const parsedReferenceTime = referenceTime.split(':');
            const referenceHours = parsedReferenceTime[0];
            const referenceMinutes = parsedReferenceTime[1];

            if (!(isNaN(referenceHours) || isNaN(referenceMinutes))) {
              const referenceDate = new Date();
              referenceDate.setHours(referenceHours);
              referenceDate.setMinutes(referenceMinutes);
              referenceDate.setMilliseconds(
                referenceDate.getMilliseconds() + (props.timeoffset || 0) * 1000,
              );

              const hours = referenceDate.getHours();
              const minutes = referenceDate.getMinutes();

              const value = `${hours}:${minutes.length === 0 ? `0${minutes}` : minutes}`;
              jQuery(this).timepicker('setTime', value);
            }
          }
        }
      });
  }
}
